import React from "react"
import Konva from "konva"

import { grey, green } from '@material-ui/core/colors';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Stage, Layer, Rect, Image as KonvaImage } from 'react-konva';

import { CanvasStyles } from "./styles"

const canvasFill = grey[200];

const Canvas = React.forwardRef(({
    size,
    onImageLoad,
    image,
    setImage
}, ref) => {
    const classes = CanvasStyles()

    const channels = ["red", "green", "blue"]
    const redChannelRef = React.useRef();
    const greenChannelRef = React.useRef();
    const blueChannelRef = React.useRef();
    const refs = {
        "red": redChannelRef,
        "green": greenChannelRef,
        "blue": blueChannelRef
    }

    const offsetMin = 10; // In Pixels
    const filterMin = 1 / 3; // Alpha
    const saturationMin = 1;
    const luminanceMin = 1;
    const [offset, setOffset] = React.useState(offsetMin);
    const [filter, setFilter] = React.useState(filterMin);
    const [saturation, setSaturation] = React.useState(saturationMin);
    const [luminance, setLuminance] = React.useState(luminanceMin);

    React.useEffect(() => {
        if (image) {
            channels.forEach(channel => {
                refs[channel].current.cache();
                refs[channel].current.getLayer().batchDraw();
            })
        }
    }, [image]);

    const handleChange = (event) => {
        setImage(null);
        if (event.target.files.length) {
            var URL = window.webkitURL || window.URL;
            var url = URL.createObjectURL(event.target.files[0]);
            var img = new Image();
            img.src = url;

            let fileName = event.target.files[0].name;
            img.name = fileName.split('.').slice(0, -1).join('.');
            img.extension = fileName.split('.').pop();

            img.onload = () => {
                onImageLoad(img);
                setImage(img);
            }
        }
    }

    const handleOffsetChange = (event, newValue) => setOffset(newValue)
    const handleFilterChange = (event, newValue) => setFilter(newValue)
    const handleSaturationChange = (event, newValue) => setSaturation(newValue)
    const handleLuminanceChange = (event, newValue) => setLuminance(newValue)

    const imageProps = {
        image,
        filters: [Konva.Filters.RGBA, Konva.Filters.HSL],
        alpha: filter,
        saturation,
        luminance,
        globalCompositeOperation: "darken",
        ...size
    }

    const sliderProps = {
        valueLabelDisplay: "auto"
    }

    return (
        <div className={classes.root}>
            <Box m={2}>
                <input
                    accept="image/*"
                    className={classes.input}
                    id="uploader"
                    type="file"
                    onChange={handleChange}
                />
                <label htmlFor="uploader">
                    <Button variant="contained" color="primary" component="span">
                        Datei hochladen ...
                    </Button>
                </label>
            </Box>

            <Stage ref={ref} {...size}>
                <Layer>
                    <Rect {...size} fill={canvasFill}></Rect>

                    <KonvaImage
                        x={-offset + offsetMin}
                        y={-offset + offsetMin}
                        ref={redChannelRef}
                        red={256}
                        green={256}
                        blue={0}
                        {...imageProps}
                    />
                    <KonvaImage
                        x={offsetMin}
                        y={offsetMin}
                        ref={greenChannelRef}
                        red={0}
                        green={256}
                        blue={256}
                        {...imageProps}
                    />
                    <KonvaImage
                        x={offset + offsetMin}
                        y={offset + offsetMin}
                        ref={blueChannelRef}
                        red={256}
                        green={0}
                        blue={256}
                        {...imageProps}
                    />
                </Layer>
            </Stage>

            <Box p={4}>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={3}>
                        <Typography gutterBottom>Filter Stärke</Typography>
                        <Slider
                            onChangeCommitted={handleFilterChange}
                            defaultValue={filterMin}
                            min={0}
                            max={1}
                            scale={(x) => Math.round((x + Number.EPSILON) * 100) / 100}
                            step={0.01}
                            {...sliderProps}
                        />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <Typography gutterBottom>Verschiebung</Typography>
                        <Slider
                            onChangeCommitted={handleOffsetChange}
                            defaultValue={offsetMin}
                            min={0}
                            {...sliderProps}
                        />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <Typography gutterBottom>Sättigung</Typography>
                        <Slider
                            onChangeCommitted={handleSaturationChange}
                            defaultValue={saturationMin}
                            max={3}
                            min={0.1}
                            step={0.1}
                            {...sliderProps}
                        />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <Typography gutterBottom>Helligkeit</Typography>
                        <Slider
                            onChangeCommitted={handleLuminanceChange}
                            defaultValue={luminanceMin}
                            max={3}
                            min={0.1}
                            step={0.1}
                            {...sliderProps}
                        />
                    </Grid>
                </Grid>
            </Box>
        </div>
    )
})

export default Canvas